import React, {Component} from 'react'
import styled from 'styled-components'
import check from '../../assets/check.png'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux';

const Content = styled.div`
  img {
    width:130px;
    margin-bottom:30px;
  }

  h2 {
    margin-bottom:8px;
  }

  a {
    background: #FFFFFF;
    border: 1px solid #34A8F0;
    box-shadow: 0 0 6px 0 rgba(0,0,0,0.21);
    border-radius: 3px;
    text-transform:uppercase;
    color: #34A8F0;
    padding: 15px 0;
    text-decoration:none;
  }

  p {
    font-family: Roboto-Light;
    font-size: 12px;
    color: #959595;
    letter-spacing: 0.94px;
    line-height: 23px;
  }
`

const Next = styled.a`
  background: #FFFFFF;
  border: 1px solid #34A8F0;
  box-shadow: 0 0 6px 0 rgba(0,0,0,0.21);
  border-radius: 3px;
  text-transform:uppercase;
  color: #34A8F0;
  padding: 15px 0;
  text-decoration:none;
  cursor:pointer;
`


class OBThree extends Component {

  render() {

    return (
      <Content>
        <img src={check} alt={'Success'}/>
        <h2>Success!</h2>
        <p>You successfully setup Narrative! We will be in touch soon.</p>
      </Content>
    )
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage: (location) => push(location)
    },
    dispatch
  );

const OnBoardingThree = connect(null, mapDispatchToProps)(OBThree);

export default OnBoardingThree



// WEBPACK FOOTER //
// ./src/containers/onBoard/onboardingThree.js